export default "__VITE_ASSET__7bc8f4b2__"